<template>
  <div class="h-100">
    <PublicProfileView />
  </div>
</template>

<script>
import PublicProfileView from './PublicProfileView.vue';


export default {
  components: { PublicProfileView },
  props: {},
  data() {
    return {
    
    };
  },
};
</script>

<style scoped></style>
